/**
 * Created by Slava on 11.04.2024
 */

// yatzy keeps the classic VictoryWindow (the victorywindowprefab feature would replace it and drop
// the score panel): score block above the rewards, rewards in a fixed order, next level on close.
// Rewards live in VictoryWindowRewards now, so the order is applied where its list is built.
VictoryWindowRewards.prototype.createRewardsList = cleverapps.extendFunc(VictoryWindowRewards.prototype.createRewardsList, function () {
    const order = ["soft", "locationProgress", "medals"];
    const rank = (reward) => {
        const index = order.indexOf(reward.type);
        return index === -1 ? order.length : index;
    };
    this.rewards.rewards.sort((a, b) => rank(a) - rank(b));

    return this._super();
});

VictoryWindow.prototype.onWindowLoaded = cleverapps.extendFunc(VictoryWindow.prototype.onWindowLoaded, function () {
    this._super();

    if (this.windowTitle) {
        this.windowTitle.text.setFont(cleverapps.styles.FONTS.VICTORY_TEXT);
    }

    if (this.boatswain) {
        this.boatswain.setIntent(Boatswain.NEXT_INTENT);
    }
});

VictoryWindow.prototype.listComponents = cleverapps.extendFunc(VictoryWindow.prototype.listComponents, function () {
    let data = [];
    const styles = cleverapps.styles.VictoryWindow.resultScore;

    const scoreBlock = new cc.Node();
    scoreBlock.setContentSize(styles.width, styles.height);
    scoreBlock.setAnchorPoint(0.5, 0.5);

    const score = Game.currentGame.score.getPoints();
    const resultText = cleverapps.UI.generateOnlyText(Messages.get("ResultsBar.YourScore"), cleverapps.styles.FONTS.SCORE_TEXT_VICTORY_WINDOW);
    const resultScore = new cleverapps.UI.ImageFont(score, cleverapps.styles.FONTS.SCORE_RESULT_VICTORY_WINDOW);

    resultText.setAlignment(styles.text);
    resultScore.setAlignment(styles.score);

    scoreBlock.addChild(resultText);
    scoreBlock.addChild(resultScore);

    const scoreBlockItems = [resultText, resultScore];

    scoreBlock.beforeWinClose = function () {
        scoreBlockItems.forEach((item) => {
            item.runAction(new cc.FadeOut(0.1));
        });
    };

    scoreBlock.showUp = function () {
        scoreBlockItems.forEach((item) => {
            item.setCascadeOpacityEnabledRecursively(true);
            item.setOpacity(0);
            item.setAlignment(item.x, item.y - styles.startOffsetY);

            item.runAction(
                new cc.Spawn(
                    new cc.MoveBy(0.4, 0, styles.startOffsetY).easing(cc.easeOut(2)),
                    new cc.FadeIn(0.4).easing(cc.easeIn(2))
                )
            );
        });
    };

    data.push(scoreBlock);

    data = data.concat(this._super());

    return data;
});

cleverapps.overrideStyles(cleverapps.styles.VictoryWindow, {
    resultScore: {
        width: 350,
        height: 60,
        startOffsetY: 25,
        text: {
            x: { align: "center", dx: -50 },
            y: { align: "center" }
        },
        score: {
            x: { align: "center", dx: 200 },
            y: { align: "center" }
        }
    }
});

cleverapps.whenAllInitialized(() => {
    if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
        cleverapps.overrideStyles(cleverapps.styles.VictoryWindow, {
            margin: 150,
            padding: {
                top: 100,
                bottom: -100
            }
        });
    }
});
